import { Link, useLocation } from 'react-router-dom'
import { Button, PageTitle } from '../components/ui'

/**
 * Адреса, которого нет.
 *
 * Раньше на его месте стоял Navigate на день: опечатка в ссылке (/admin/rules вместо
 * /admin/policies), устаревшая закладка и просто мусор в адресной строке выглядели как
 * успешный переход — человек попадал на расписание и решал, что раздел переехал сюда
 * или что прав у него больше нет. Молчаливое перенаправление хуже отказа: оно не даёт
 * заметить ошибку и подталкивает искать несуществующую причину.
 *
 * Сам адрес показан дословно: чаще всего ошибка видна прямо в нём.
 */
export function NotFoundPage() {
  const { pathname } = useLocation()

  return (
    <div className="mx-auto max-w-2xl">
      <PageTitle>Такой страницы нет</PageTitle>
      <div className="card p-6">
        <p className="text-sm text-muted">
          В системе нет адреса <span className="tnum font-medium text-fg">{pathname}</span>. Скорее
          всего, ссылка набрана с опечаткой или ведёт на раздел, которого больше нет.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <Link to="/">
            <Button variant="primary">Расписание на день</Button>
          </Link>
          <Link to="/meetings">
            <Button variant="ghost">Мои встречи</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
